<script lang="ts">
const scrollToPrivacy= () => {
    document.getElementById("privacy_section").scrollIntoView();
  };
</script>

<svelte:head>
  <title>PocketBirbal</title>
</svelte:head>
 

<nav class="flex bg-purple-50">
    <a href="/#/pocketbirbal" class="p-2 w-1/2">
      <img
        src="../images/pocketbirbal/favicon.png"
        width="42"
        alt="PocketBirbal logo"
      />
    </a>
    <h5 class="font-black text-xl text-center pt-3 w-1/2">
      Pocket Birbal
    </h5>
    <!-- Menu -->
    <div class="text-right w-1/2 p-2">
      <button
        type="button"
        on:click={scrollToPrivacy}
        class="bg-green-900 text-gray-50 px-3 py-2 rounded-3xl text-md hover:bg-boyblue-900 hidden lg:inline"
        >Privacy Policy</button
      >
    </div>
  </nav>
  <!--hero section-->
  <section id="hero">
    <div
      class="flex flex-col bg-gradient-to-r from-green-500 to-purple-900 text-center 
      items-center bg-repeat bg-opacity-700 bg-center"
    >
      <h1 class="text-2xl   lg:text-4xl font-black text-gray-50 pb-15">
        Ad-Free Currency Converter
      </h1>
      <h5 class="text-md  pb-5  font-black text-gray-500 ">
        Millions to Lakhs and Crores to Millions
      </h5>
      
      <!-- svelte-ignore a11y-img-redundant-alt -->
      <img
        src="../images/pocketbirbal/aedtoinr.png"
        width="300"
        alt="pocketbirbal image"
        class="-mb-52"
      />
    </div>
    <div
    class="flex flex-wrap justify-center bg-steel-400  text-center pt-60 md:gap-x-14">
   
    </div>
    <div
      class="flex flex-wrap justify-center bg-steel-400  text-center pt-10 md:gap-x-14"
    >
   
      <img
        src="../images/logmypoop/log_my_poop_coming_soon_app_store.png"
        alt="pocketbirbal available now apple at app store"
        class="p-4"
      />
 
   
      <img
        src="../images/logmypoop/log_my_poop_coming_soon_play_store.png"
        alt="pocketbirbal available now apple at play store"
        class="p-4"
      />
   
     
    </div>
  </section>

  <div class="flex flex-wrap justify-center bg-steel-400  text-center mb-300 px-30" >
    <div class="p-10">
        <h4>Privacy Policy</h4> 
        <div class="text-xl px-100" id="privacy_section">
            PocketBirbal never asks for personal data like name, email or phone number ever so nothing like that is ever saved to the server. <br/> We dont collect any user data and hence there is no question of sharing it with anyone or need for any provision to delete data.
        </div>
        <br/>
    </div>

    <div class="p-2">
        <h4>Any Questions ? Please contact</h4> 
        <div class="text-xl px-100" id="privacy_section">
            <span class=" mb-10 text-md text-blue-700 lg:text-xl md:text-lg">admin@squaredojo.com</span>
        </div>
        <br/>
    </div>
      
        <div class="container mx-auto text-center text-gray-700 pb-10 opacity-90">
            2023 | Made by <a href=".">SquareDojo</a>
          </div>
        <br/>
   
</div>
